<template>
  <div class="modal-content max-operation-confirm">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Confirm changes') }}</h4>
    </div>
    <div class="modal-body">
      <p>
        <strong>{{ interfaceTitle }}</strong>
        {{ _('wants to make these changes:') }}
      </p>
      <p class="max-operation-confirm__what">
        {{ operationLabel(confirm.operation) }}
        <span v-if="confirm.label" class="text-muted">· {{ confirm.label }}</span>
      </p>
      <table class="table table-condensed">
        <caption>{{ fieldLabel }}</caption>
        <thead>
          <tr>
            <th scope="col">{{ _('Item') }}</th>
            <th v-if="showKeys" scope="col">{{ _('Field') }}</th>
            <th scope="col">{{ _('Current value') }}</th>
            <th scope="col">{{ _('New value') }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- One record can have several rows (one per key), so rows are keyed by position -->
          <tr v-for="(change, index) in visibleChanges" :key="index">
            <td>{{ change.label || ('#' + change.id) }}</td>
            <td v-if="showKeys">{{ operationChangeKey(confirm, change) }}</td>
            <td class="text-muted">{{ operationValue(confirm.field, change.from, metadataKey(change)) }}</td>
            <td><strong>{{ operationValue(confirm.field, change.to, metadataKey(change)) }}</strong></td>
          </tr>
        </tbody>
      </table>
      <p v-if="hiddenCount" class="text-muted">{{ _('And %s more.').replace('%s', hiddenCount) }}</p>
      <p v-if="confirm.unchanged" class="text-muted">{{ _('%s already had this value and are not changed.').replace('%s', confirm.unchanged) }}</p>
      <p v-if="confirm.missing && confirm.missing.length" class="text-warning">
        <i class="fa fa-fw fa-triangle-exclamation" aria-hidden="true"></i>
        {{ _('%s were not found and are skipped.').replace('%s', confirm.missing.length) }}
      </p>
      <p v-if="confirm.ineligible && confirm.ineligible.length" class="text-warning">
        <i class="fa fa-fw fa-triangle-exclamation" aria-hidden="true"></i>
        {{ ineligibleText }}
      </p>
      <p class="text-muted small">{{ _('Johku checked these values just now. The change is recorded in the tool history with your name.') }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" v-on:click="$emit('close')">{{ _('Cancel') }}</button>
      <button ref="confirmButton" type="button" class="btn btn-primary" v-on:click="$emit('confirm')">
        <i class="fa fa-fw fa-check" aria-hidden="true"></i> {{ _('Make %s changes').replace('%s', confirm.changes.length) }}
      </button>
    </div>
  </div>
</template>

<script>
import maxspecs from '~/lib/maxspecs'

const SHOWN = 50

export default {
  props: ['confirm', 'interfaceTitle'],
  emits: ['close', 'confirm'],
  mixins: [maxspecs],
  computed: {
    fieldLabel () {
      return this.maxOperationFields[this.confirm.field] || this.confirm.field
    },
    visibleChanges () {
      return this.confirm.changes.slice(0, SHOWN)
    },
    showKeys () {
      return this.visibleChanges.some(change => this.operationChangeKey(this.confirm, change) !== '')
    },
    hiddenCount () {
      return Math.max(0, this.confirm.changes.length - SHOWN)
    },
    ineligibleText () {
      const text = this.maxOperationIneligible[this.confirm.operation] || this._('%s cannot be changed this way and are skipped.')
      return text.replace('%s', this.confirm.ineligible.length)
    }
  },
  mounted () {
    this.$nextTick(() => this.$refs.confirmButton && this.$refs.confirmButton.focus())
  }
}
</script>

<style scoped>
.max-operation-confirm__what {
  font-size: 16px;
}
.max-operation-confirm .table {
  margin-bottom: 10px;
}
.max-operation-confirm .table td {
  overflow-wrap: anywhere;
}
</style>
